/*
 * Productvideo's in de galerij van de productpagina.
 *
 * Het thema pauzeert bij het wisselen van slide wel de vórige video, maar
 * start de nieuwe niet. Daardoor moest de bezoeker zelf op play drukken.
 *
 * Autoplay als attribuut is hier geen optie: in de carousel staan alle slides
 * in de DOM, dus dan zouden alle video's tegelijk laden en spelen. We starten
 * alleen de video van de zichtbare slide en pauzeren de rest.
 *
 * De selectie loopt via data-video-autoplay, niet via een class. De
 * snelweergave gebruikt namelijk dezelfde class 'product-images' als de
 * productpagina; daar moet de bediening juist zichtbaar blijven.
 *
 * Video's spelen altijd zonder geluid. Dat is ook een browsereis: automatisch
 * afspelen wordt alleen toegestaan wanneer de video gedempt is.
 */
(function () {
  'use strict';

  var VIDEO = '[data-video-autoplay="true"] video';
  var SLIDE = '.product-images__slide';

  function videos(root) {
    return (root || document).querySelectorAll(VIDEO);
  }

  function speel(video) {
    if (!video) return;
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.setAttribute('playsinline', '');

    var poging = video.play();
    if (poging && typeof poging.catch === 'function') {
      // Geweigerd betekent dat de browser afspelen blokkeert. Geen storing:
      // de video blijft dan op zijn eerste frame staan.
      poging.catch(function () {});
    }
  }

  function pauzeer(video) {
    if (video && !video.paused) video.pause();
  }

  /* Speel de video van de zichtbare slide, pauzeer alle andere.
   *
   * In de verticale galerij is er geen carousel en dus geen is-selected. Daar
   * bepaalt de zichtbaarheid in beeld of een video hoort te spelen; dat regelt
   * de IntersectionObserver onderaan dit bestand. */
  function synchroniseer(root) {
    var lijst = videos(root);

    for (var i = 0; i < lijst.length; i++) {
      var video = lijst[i];
      if (video.closest('.product-gallery--vertical')) continue;

      var slide = video.closest(SLIDE);
      var zichtbaar = slide ? slide.classList.contains('is-selected') : true;

      if (zichtbaar) speel(video);
      else pauzeer(video);
    }
  }

  function koppel(container) {
    if (!container || container.dataset.videoAutoplayInit === 'true') return;
    container.dataset.videoAutoplayInit = 'true';

    // Flickity markeert de zichtbare cel met is-selected. Meekijken op
    // class-wijzigingen werkt ongeacht hoe de carousel is opgestart.
    new MutationObserver(function () {
      synchroniseer(container);
    }).observe(container, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true,
    });

    synchroniseer(container);

    // Flickity zet is-selected pas na initialisatie; nog een keer kijken
    // voorkomt dat een video als eerste slide blijft stilstaan.
    setTimeout(function () {
      synchroniseer(container);
    }, 400);
  }

  function init() {
    var lijst = videos();

    for (var i = 0; i < lijst.length; i++) {
      var galerij = lijst[i].closest('.product-gallery-container') || lijst[i].closest('.product-images');
      if (galerij) koppel(galerij);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // De theme editor bouwt secties opnieuw op.
  document.addEventListener('shopify:section:load', init);

  // Bij een variantwissel kan de galerij naar een andere slide springen.
  document.addEventListener('product:variant-change', function () {
    synchroniseer();
  });

  /* Zichtbaarheid bepaalt of een video speelt.
   *
   * In de verticale galerij is dit de enige aansturing: komt de video in
   * beeld, dan start hij; scrolt hij eruit, dan pauzeert hij. In de carousel
   * dient dit alleen om te pauzeren wat buiten beeld staat — daar beslist
   * is-selected welke video mag spelen. */
  function volgZichtbaarheid() {
    if (!('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var verticaal = entry.target.closest('.product-gallery--vertical');

          if (entry.isIntersecting) {
            if (verticaal) speel(entry.target);
          } else {
            pauzeer(entry.target);
          }
        });
      },
      { threshold: 0.35 }
    );

    var lijst = videos();
    for (var i = 0; i < lijst.length; i++) io.observe(lijst[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', volgZichtbaarheid);
  } else {
    volgZichtbaarheid();
  }
})();
